import ComboList from '../components/ComboList';
import ComboSessionsList from '../components/ComboSessionsList';
import ComboTicketsList from '../components/ComboTicketsList';

export const defaultBreadcrumbs = [
  {
    name : ['COMBO', 'BREADCRUMB', 'STEP1', 'NAME'],
    active : false,
    title : ['COMBO', 'BREADCRUMB', 'STEP1', 'TITLE'],
    description : ['COMBO', 'BREADCRUMB', 'STEP1', 'DESCRIPTION'],
    component : () => <ComboList />,
  },
  {
    name : ['COMBO', 'BREADCRUMB', 'STEP2', 'NAME'],
    active : false,
    title : ['COMBO', 'BREADCRUMB', 'STEP2', 'TITLE'],
    description : ['COMBO', 'BREADCRUMB', 'STEP2', 'DESCRIPTION'],
    component : () => <ComboSessionsList />,
  },
  {
    name : ['COMBO', 'BREADCRUMB', 'STEP3', 'NAME'],
    active : false,
    title : ['COMBO', 'BREADCRUMB', 'STEP3', 'TITLE'],
    description : ['COMBO', 'BREADCRUMB', 'STEP3', 'DESCRIPTION'],
    component : () => <ComboTicketsList />,
  },
];

export const initialComboData = {
  id : null,
  name : '',
  comboDates : [],
};
